import React from "react";
import { withTranslation } from "react-i18next";

const BigSmallComponent = (props) => {
  const betsPosition = {
    as: "as",
    kop: "kop",
    kepala: "kepala",
    ekor: "ekor",
  };

  const betChoose = ["big", "small"];

  const combinedKey = {
    as_big: "as_besar",
    as_small: "as_kecil",
    kop_big: "kop_besar",
    kop_small: "kop_kecil",
    kepala_big: "kepala_besar",
    kepala_small: "kepala_kecil",
    ekor_big: "ekor_besar",
    ekor_small: "ekor_kecil",
  };

  return (
    <table className="tbl_3 fifty_tbl_1">
      <thead>
        <tr>
          <th className="table-position">{props.t("position")}</th>
          <th>
            <table className="tbl_hd_1">
              <thead>
                <tr>
                  <th className="guess-thtable">{props.t("guess")}</th>
                  <th className="offtext">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        className="guess-span"
                        style={{

                          padding: "0 10px",
                          background: "none",
                          border: "none",
                        }}
                      >
                        {props.t("kei")}
                      </span>
                      <input
                        id="inputs"
                        type="text"
                        autoComplete="off"
                        placeholder="Auto Bet"
                        value={props.defaultValue}
                        onChange={props.handleDeafultInputChange}
                        onBlur={props.handleDeafultInputBlur}
                        className="input-odd"
                      // style={{ padding: "8px 0px" }}

                      // style={{ padding: "8px 0px" }}
                      />
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </th>

        </tr>
      </thead>
      <tbody>
        {Object.values(betsPosition).map((val, index) => (
          <tr>
            <td
              className={
                index % 2 == 0
                  ? "first-input-row even-row"
                  : "first-input-row odd-row"
              }
              style={{ padding: "0" }}
            >
              {props.t(val)}
              <input type="hidden" value={val} />
            </td>
            <td
              style={{ padding: "0" }}
              className={
                index % 2 == 0
                  ? "first-input-row even-row"
                  : "first-input-row odd-row"
              }
            >
              <table className="data-table tbl_2" style={{ border: 0 }}>
                <tbody>
                  {betChoose.map((item, ind) => (
                    <tr className="odd-even-row">
                      <td className="second-row">
                        {props.t(item)}
                        <input
                          name={`${val}_${item}`}
                          value={item == "big" ? "besar" : "kecil"}
                          type="hidden"
                        />
                      </td>
                      <td className="third-even-row">
                        <div style={{ display: "flex" }}>
                          <input
                            type="text"
                            className="kei-row"
                            // value={betDiscount.kei_as_besar + '%'}
                            value={
                              props.betDiscount.kei_as_besar
                                ? props.betDiscount.kei_as_besar + "%"
                                : ""
                            }
                            readOnly
                            style={{ padding: "0 10px", background: "none", border: "none" }}
                          />
                          <input
                            type="text"
                            placeholder="Bet"
                            name={`${val}_${item}`}
                            value={props.beli[combinedKey[`${val}_${item}`]] || ''}
                            autoComplete="off"
                            onChange={(e) => props.handleInputChange(e, index * 2, ind)}
                            onBlur={(e) => props.handleInputBlur(e, index * 2, ind)}
                            onFocus={(e) => props.handleInputFocus(e, index * 2, ind)}
                            inputMode="decimal"
                            pattern="[0-9]*[.,]?[0-9]**"
                            id="inputs" style={{ padding: "8px 0px" }}
                            className="input-odd"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default withTranslation()(BigSmallComponent);
